import { Link } from "react-router-dom";
import { relatedTopics } from "@/mocks/topic";

export default function RelatedSidebar() {
  return (
    <aside aria-labelledby="related-title" className="space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 id="related-title" className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950">
          <i className="ri-links-line text-xl text-primary-500" aria-hidden="true" />
          相关话题推荐
        </h2>
        <ul className="mt-4 space-y-3">
          {relatedTopics.map((topic, index) => (
            <li key={topic.id}>
              <Link
                to={`/topic/${topic.id}`}
                className="group flex items-start gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded font-heading text-xs font-black ${
                    index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                  aria-hidden="true"
                >
                  {index + 1}
                </span>
                <span className="flex-1">
                  <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                    {topic.title}
                  </span>
                  <span className="mt-1 block text-xs text-foreground-400">热度 {topic.heat}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-accent-200 bg-accent-50/50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-black text-foreground-950">
          <i className="ri-quill-pen-line text-lg text-accent-700" aria-hidden="true" />
          想写点什么？
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          如果你对这个话题有更完整的梳理，欢迎投稿「二创解读」，优质内容会署名发布。
        </p>
        <Link
          to="/#contact"
          className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-3 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-600"
        >
          <i className="ri-send-plane-line text-base" aria-hidden="true" />
          去投稿
        </Link>
      </div>
    </aside>
  );
}